import type { SxProps, Theme } from '@mui/material/styles';

export const guaranteesApplicationStatusStyles = {
  chip: (theme: Theme) => ({
    minWidth: 89,
    height: 27,
    borderRadius: '100px',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.common.white,
    '& .MuiChip-label': {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      whiteSpace: 'nowrap',
      paddingLeft: theme.spacing(1.5),
      paddingRight: theme.spacing(1.5),
      paddingTop: theme.spacing(0.5),
      paddingBottom: theme.spacing(0.5),
      fontSize: '14px',
      lineHeight: '19px',
      fontWeight: 500,
    },
    '&.MuiChip-colorDefault': {
      backgroundColor: `${theme.palette.primary['200']} !important`,
      color: theme.palette.primary.main,
    },
    '&.MuiChip-colorPrimary': {
      backgroundColor: `${theme.palette.primary.main} !important`,
      color: theme.palette.common.white,
    },
    '&.MuiChip-colorInfo': {
      backgroundColor: `${theme.palette.info.main} !important`,
      color: theme.palette.common.white,
    },
    '&.MuiChip-colorSuccess': {
      backgroundColor: `${theme.palette.covenantStatus.success} !important`,
      color: theme.palette.common.white,
    },
    '&.MuiChip-colorError': {
      backgroundColor: `${theme.palette.covenantStatus.error} !important`,
      color: theme.palette.common.white,
    },
    '&.MuiChip-colorWarning': {
      backgroundColor: `${theme.palette.covenantStatus.warning} !important`,
      color: theme.palette.common.white,
    },
  }),
  withInfo: (theme: Theme) => ({
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
  }),
  label: {
    lineHeight: 1.1,
  } as SxProps<Theme>,
  info: (theme: Theme) => ({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.grey.infoIconGrey,
    cursor: 'help',
    outline: 'none',
    transition: 'color 0.2s ease',
    '&:hover': {
      color: theme.palette.primary.main,
    },
    '&:focus-visible': {
      color: theme.palette.primary.main,
    },
  }),
  tooltip: (theme: Theme) => ({
    position: 'relative',
    overflow: 'visible',
    maxWidth: 260,
    padding: theme.spacing(1, 1.25),
    borderRadius: theme.spacing(0.75),
    border: `1px solid ${theme.palette.border.subtle}`,
    backgroundColor: theme.palette.common.white,
    boxShadow: theme.palette.shadow.tooltip,
    color: theme.palette.text.primary,
    fontFamily: '"Nunito Sans", sans-serif',
    fontSize: '0.8125rem',
    fontWeight: 400,
    lineHeight: '16px',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: '-8px',
      left: '18px',
      width: 14,
      height: 14,
      backgroundColor: theme.palette.common.white,
      borderTop: `1px solid ${theme.palette.border.subtle}`,
      borderLeft: `1px solid ${theme.palette.border.subtle}`,
      transform: 'rotate(45deg)',
      boxShadow: theme.palette.shadow.tooltipArrow,
      zIndex: -1,
    },
  }),
} as const;
